export default __webpack_public_path__ + "static/media/23.c3cd5161.png";